import { createSvgIcon } from "@mui/material";

const ApiGatewayIcon = createSvgIcon(
  <svg viewBox="0 0 41 40" fill="none">
    <path
      d="M0.333496 10.1587C0.333496 4.54822 5.10913 0 11.0002 0H29.6668C35.5579 0 40.3335 4.54822 40.3335 10.1587V29.8413C40.3335 35.4518 35.5579 40 29.6668 40H11.0002C5.10913 40 0.333496 35.4518 0.333496 29.8413V10.1587Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M20.335 9.37966C20.335 7.66144 21.7279 6.26855 23.4461 6.26855H31.1042C32.8224 6.26855 34.2153 7.66145 34.2153 9.37967V16.2163C34.2153 17.9345 32.8224 19.3274 31.1042 19.3274H23.4461C21.7279 19.3274 20.335 17.9345 20.335 16.2163V9.37966Z"
      fill="#B3E5FC"
    />
    <path
      d="M6.51904 24.166C6.51904 22.4478 7.91193 21.0549 9.63015 21.0549H17.2883C19.0065 21.0549 20.3994 22.4478 20.3994 24.166V31.0026C20.3994 32.7208 19.0065 34.1137 17.2883 34.1137H9.63016C7.91194 34.1137 6.51904 32.7208 6.51904 31.0026V24.166Z"
      fill="#B3E5FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.036 9.36519C15.9928 9.36519 15.1471 10.2109 15.1471 11.2541V11.9095C15.1471 12.5845 14.5999 13.1317 13.9249 13.1317H11.2323C10.1891 13.1317 9.3434 13.9774 9.3434 15.0206V29.1228C9.3434 30.166 10.1891 31.0117 11.2323 31.0117H15.9697C16.3993 31.0117 16.7475 31.3599 16.7475 31.7895C16.7475 32.219 16.3993 32.5673 15.9697 32.5673H11.2323C9.32997 32.5673 7.78784 31.0251 7.78784 29.1228V15.0206C7.78784 13.1183 9.32997 11.5762 11.2323 11.5762H13.5916V11.2541C13.5916 9.35176 15.1337 7.80963 17.036 7.80963H20.6852C21.1148 7.80963 21.463 8.15785 21.463 8.58741C21.463 9.01696 21.1148 9.36519 20.6852 9.36519H17.036Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.1544 31.0117C24.1976 31.0117 25.0433 30.166 25.0433 29.1228V28.4674C25.0433 27.7924 25.5905 27.2451 26.2655 27.2451H28.9581C30.0013 27.2451 30.847 26.3995 30.847 25.3563V11.2541C30.847 10.2109 30.0013 9.36519 28.9581 9.36519H24.2207C23.7911 9.36519 23.4429 9.01697 23.4429 8.58742C23.4429 8.15786 23.7911 7.80964 24.2207 7.80964H28.9581C30.8605 7.80964 32.4026 9.35177 32.4026 11.2541V25.3563C32.4026 27.2586 30.8605 28.8007 28.9581 28.8007H26.5989V29.1228C26.5989 31.0251 25.0567 32.5673 23.1544 32.5673H19.283C18.8534 32.5673 18.5052 32.219 18.5052 31.7895C18.5052 31.3599 18.8534 31.0117 19.283 31.0117H23.1544Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0932 12.7598C15.4401 12.5064 15.9267 12.5822 16.1801 12.929L16.9655 14.0042C17.2189 14.3511 17.1431 14.8377 16.7962 15.0911C16.4494 15.3445 15.9628 15.2687 15.7094 14.9218L14.9239 13.8466C14.6706 13.4997 14.7463 13.0131 15.0932 12.7598ZM17.4495 15.9854C17.7964 15.732 18.283 15.8078 18.5364 16.1546L20.1072 18.305C20.3606 18.6519 20.2848 19.1385 19.938 19.3919C19.5911 19.6453 19.1045 19.5695 18.8511 19.2226L17.2802 17.0722C17.0269 16.7254 17.1026 16.2388 17.4495 15.9854ZM20.5912 20.2862C20.9381 20.0328 21.4247 20.1086 21.6781 20.4554L23.2489 22.6059C23.5023 22.9527 23.4266 23.4393 23.0797 23.6927C22.7328 23.9461 22.2462 23.8703 21.9928 23.5234L20.422 21.373C20.1686 21.0262 20.2444 20.5396 20.5912 20.2862ZM23.733 24.587C24.0798 24.3336 24.5664 24.4094 24.8198 24.7563L25.6052 25.8315C25.8586 26.1783 25.7828 26.6649 25.436 26.9183C25.0891 27.1717 24.6025 27.0959 24.3491 26.749L23.5637 25.6738C23.3103 25.327 23.3861 24.8404 23.733 24.587Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.0689 12.0202C28.6393 12.0202 28.2911 12.3684 28.2911 12.798C28.2911 13.2946 27.8884 13.6974 27.3918 13.6974H23.1989C22.7693 13.6974 22.4211 14.0456 22.4211 14.4751C22.4211 14.9047 22.7693 15.2529 23.1989 15.2529H27.3918C28.7475 15.2529 29.8467 14.1537 29.8467 12.798C29.8467 12.3684 29.4985 12.0202 29.0689 12.0202Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.0068 12.248C24.7031 11.9443 24.2106 11.9443 23.9069 12.248L22.2297 13.9252C21.926 14.2289 21.926 14.7214 22.2297 15.0251L23.9069 16.7023C24.2106 17.006 24.7031 17.006 25.0068 16.7023C25.3106 16.3985 25.3106 15.906 25.0068 15.6023L23.8796 14.4751L25.0068 13.348C25.3106 13.0442 25.3106 12.5517 25.0068 12.248Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6538 28.3621C12.0833 28.3621 12.4315 28.0138 12.4315 27.5843C12.4315 27.0876 12.8343 26.6849 13.3309 26.6849H17.5238C17.9533 26.6849 18.3016 26.3367 18.3016 25.9071C18.3016 25.4776 17.9533 25.1294 17.5238 25.1294H13.3309C11.9751 25.1294 10.876 26.2285 10.876 27.5843C10.876 28.0138 11.2242 28.3621 11.6538 28.3621Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7161 28.1343C16.0198 28.438 16.5123 28.438 16.816 28.1343L18.4932 26.4571C18.7969 26.1534 18.7969 25.6609 18.4932 25.3572L16.816 23.68C16.5123 23.3763 16.0198 23.3763 15.7161 23.68C15.4123 23.9838 15.4123 24.4762 15.7161 24.78L16.8433 25.9071L15.7161 27.0343C15.4123 27.3381 15.4123 27.8305 15.7161 28.1343Z"
      fill="#136B94"
    />
  </svg>,
  "ApiGatewayIcon"
);

export default ApiGatewayIcon;
